import styled from 'styled-components';

export const StyledMintModalHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
  padding-bottom: 1.25rem;
  height: calc(1.25rem + 28px);
  gap: 2px;
  border-bottom: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};

  .mint-modal-title-question {
    text-transform: uppercase;
    font-family: "BebasNeue";
    font-size: 2rem;
    font-weight: 500;
    color: ${({ theme }) => theme.selection};
    line-height: 1;
    padding-top: 0.375rem;
  }

  .mint-modal-title-stub-short {
    background: ${({ theme }) => theme.menuTitle};
    width: 20px;
    min-width: 20px;
    height: 100%;
  }

  .mint-modal-title-stub-long {
    background: ${({ theme }) => theme.menuTitle};
    width: 100%;
    height: 100%;
  }

  .mint-modal-icon {
    width: 1.5rem;
  }

  .mint-modal-title {
    text-transform: uppercase;
    height: 100%;
    padding: 0 6px;
    font-family: "BebasNeue";
    font-size: 2em;
    font-weight: 500;
    color: white;
    line-height: 1;
    white-space: nowrap;
  }
`;

